import { HTTP } from './_http';
import { queryString } from '../../helpers';

const getPaymentMethod = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.get(`/Payment/GetGroupPolicyPayment?${queryString(form)}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const changePaymentMethod = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.get(`/Payment/SavePaymentMethodChange?${queryString(form)}`)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const getReceiptDetails = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/AutomaticAttendanceSystem/GetReceiptDetails`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

const printReceiptDetails = (form) => {
	return new Promise((resolve, reject) => {
		return HTTP.post(`/AutomaticAttendanceSystem/PrintReceiptDetails`, form)
			.then(response => resolve(response.data))
			.catch(error => reject(error))
	})
}

export { getPaymentMethod, changePaymentMethod, getReceiptDetails, printReceiptDetails }